import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from 'components/ui/use-toast';
import * as Api from '../api';
import * as Types from '../types';

interface ShareData extends Types.IApi.Share.Request {
  collectionId: string;
}

const useShare = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async ({ collectionId, ...data }: ShareData) => {
      const response = await Api.share(collectionId, data);
      return response.data.data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['collections', 'single', variables.collectionId] });
      toast.success('Collection shared', {
        description: 'Collection has been shared successfully.',
      });
    },
    onError: (error: any) => {
      toast.error('Error', {
        description: error?.response?.data?.message || 'Failed to share collection',
      });
    },
  });
};

export default useShare;
